import React, { Component } from "react";
import { GoogleMap, Marker, useLoadScript } from "@react-google-maps/api";
import { VEHICLE_TYPE_MOTORCYCLE } from "constants/Types";

// Constants for your API key and default center
const API_KEY = `${process.env.REACT_APP_GOOGLE_MAPS_API_KEY}&v=3.31&libraries=geometry,places`;
const DEFAULT_CENTER = { lat: 33.8221042, lng: 35.7588642 };

const MapPins = (props) => {
  const { driver, height, width } = props;

  // Load Google Maps script
  const { isLoaded, loadError } = useLoadScript({
    googleMapsApiKey: API_KEY,
    libraries: ["geometry", "places"],
  });

  if (loadError) return <div>Error loading maps</div>;
  if (!isLoaded) return <div>Loading Maps...</div>;

  // Set map center based on driver location or default location
  const center = driver && driver.longitude !== 0 && driver.latitude !== 0
    ? { lat: parseFloat(driver.latitude), lng: parseFloat(driver.longitude) }
    : DEFAULT_CENTER;

  return (
    <div style={{ height: height || "100vh", width: width || "100%" }}>
      <GoogleMap
        mapContainerStyle={{ height: "100%", width: "100%" }}
        center={center}
        zoom={15}
      >
        {driver && driver.latitude && driver.longitude && (
          <Marker
            key={driver.id}
            position={{ lat: driver.latitude, lng: driver.longitude }}
            label={{
              text: `${driver.name}`,
              color: "white",
              fontSize: "14px",
              fontWeight: "bold",
            }}
            icon={{
              path: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2z",
              fillColor: "rgb(226, 170, 1)",
              fillOpacity: 1,
              strokeColor: "rgb(226, 170, 1)",
              strokeWeight: 2,
              scale: 1.5,
            }}
          />
        )}
      </GoogleMap>
    </div>
  );
};

export default MapPins;
